export class EntriesConfig { 
    showHorseOne: boolean;
    showContestantTwo: boolean;
    showHorseTwo: boolean;

    constructor() {
        this.showHorseOne = true;
        this.showContestantTwo = false;
        this.showHorseTwo = false;
    }
}


// WEBPACK FOOTER //
// ./src/model/entriesConfig.ts